












































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlSelect from '@/components/common/control/CtrlSelect.vue';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import G_040_HatchuConfirm_ChildHeaderInput_Table from '@/components/G_kaigai/G_040_HatchuConfirm_ChildHeaderInput_Table.vue';
import G_040_HatchuEntry_RenrakuEntry from '@/components/G_kaigai/G_040_HatchuEntry_RenrakuEntry.vue';
import {
  MeishoBunruiCd,
  KojoJotaiKb,
  ShoriKb,
  UmuFlg,
  OutStatus,
  Color,
} from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import {
  isShorikbREFER,
  isShorikbUPD,
  dateNumToStr,
  dateStrToNum,
} from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_040_HatchuEntry_ChildHeaderInput',
  components: {
    CtrlDatePicker,
    CtrlNormalBtn,
    CtrlNormalTxt,
    CtrlMessageDialog,
    CtrlSelect,
    G_040_HatchuConfirm_ChildHeaderInput_Table,
    VuePdfEmbed,
    G_040_HatchuEntry_RenrakuEntry,
  },
  props: {
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
      childHeaderTitle: 'common/childHeaderTitle',
    }),
  },
  data: () => ({
    BUTTON,
    UmuFlg,
    KojoJotaiKb,
    ShoriKb,
    MeishoBunruiCd,
    Color,
    show: true,
    childHeaderInput: {} as any,
    showMessageDialog: false,
    messageID: '',
    messageTextParam: [] as any,
    kojoJotaiKbObj: { meishoCd: '' },
    kojoJotaiKbSelectedItems: [] as any,
    isCloseScreen: false,
    valid: true,
    showPreviewPDF: false,
    childShowRenrakuEntry: false,
    childRenrakuItem: {},
  }),
  methods: {
    isShorikbREFER,
    isShorikbUPD,
    hide(reload = true) {
      this.show = false;
      this.$emit('hide', reload);
    },
    getKojoJotaiKbSelectedItems() {
      this.$store
        .dispatch('common/getMeishoMst', {
          meishoBunruiCd: MeishoBunruiCd.KOJO_JOTAI_KB,
          mukoUmuFlg: isShorikbREFER(this.shoriKb) ? UmuFlg.ARI : UmuFlg.NASHI,
        })
        .then((res: any) => {
          let kojoJotaiKbSelectedItems = [] as any;
          if (res.data.responseData && res.data.responseData.length > 0)
            kojoJotaiKbSelectedItems = res.data.responseData.map(
              (item: any) => {
                item.meishoCd = +item.meishoCd;
                return item;
              }
            );
          this.kojoJotaiKbSelectedItems = kojoJotaiKbSelectedItems;
        });
    },
    async handleValidate() {
      // タイマー入れる
      await new Promise((resolve) => setTimeout(resolve, 300));

      this.showMessageDialog = true;
      this.messageID = 'KI_Q100';
      this.messageTextParam = ['変更'];
    },
    async handleOkMessageDialog() {
      this.showMessageDialog = false;
      if (this.isCloseScreen || this.messageID === 'KI_W107') {
        this.hide();
        return;
      }

      // 別紙添付が削除されていた場合は画面を閉じて一覧をリロード
      if (this.messageID === 'KI_W124') {
        this.hide(true);
        return;
      }

      const data = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          targetInfo: [
            {
              hatchuJigyoshoCd: this.childHeaderInput.hatchuJigyoshoCd,
              hatchuEntryYmd: dateStrToNum(
                this.childHeaderInput.hatchuEntryYmd
              ),
              hatchuNo: this.childHeaderInput.hatchuNo,
              hatchuShuseiCount: this.childHeaderInput.hatchuShuseiCount,
              koshinCountHeader: this.childHeaderInput.koshinCountHeader,
              koshinCountDetailSum: this.childHeaderInput.koshinCountDetailSum,
              kojoJotaiKb: this.childHeaderInput.kojoJotaiKb,
            },
          ],
        },
      };

      if (this.messageID === 'KI_Q100') {
        // ローディング・スタート
        this.$store.dispatch('common/setIsLoading', true);

        this.$store
          .dispatch('g040/putHatchuConfirm', data)
          .then((response: any) => {
            if (
              response &&
              response.status == 200 &&
              response.data &&
              response.data.error &&
              response.data.error.messageID &&
              response.data.error.outStatus &&
              response.data.error.outStatus != OutStatus.NORMAL
            ) {
              this.showMessageDialog = true;
              this.messageID = response.data.error.messageID;
              this.messageTextParam = response.data.error.messageArgs;

              if (response.data.error.outStatus === OutStatus.EXCLUSIVE_ERR) {
                this.isCloseScreen = true;
              }

              if (response.data.error.outStatus === OutStatus.CHECK_ERR) {
                this.isCloseScreen = false;
              }
              // ローディング・ストップ
              this.$store.dispatch('common/setIsLoading', false);
              return;
            }

            // ローディング・ストップ
            this.$store.dispatch('common/setIsLoading', false);
            this.hide(true);
          });
      }
    },
    getData() {
      let params = {
        hatchuJigyoshoCd: this.childHeaderInput.hatchuJigyoshoCd,
        hatchuEntryYmd: dateStrToNum(this.childHeaderInput.hatchuEntryYmd),
        hatchuNo: this.childHeaderInput.hatchuNo,
        hatchuShuseiCount: this.childHeaderInput.hatchuShuseiCount,
      };
      this.$store
        .dispatch('g040/getHatchuConfirmItem', params)
        .then((response: any) => {
          if (
            response &&
            response.status == 200 &&
            response.data &&
            response.data.error &&
            response.data.error.messageID &&
            response.data.error.outStatus &&
            response.data.error.outStatus != OutStatus.NORMAL
          ) {
            this.showMessageDialog = true;
            this.messageID = response.data.error.messageID;
            this.messageTextParam = response.data.error.messageArgs;
            this.isCloseScreen = true;
            return;
          }

          if (!response.data.responseData) return;
          if (
            isShorikbUPD(this.shoriKb) &&
            (response.data.responseData.koshinCountHeader !==
              this.childHeaderInput.koshinCountHeader ||
              response.data.responseData.koshinCountDetailSum !==
                this.childHeaderInput.koshinCountDetailSum)
          ) {
            this.showMessageDialog = true;
            this.messageID = 'KI_W107';
            this.messageTextParam = [];
            return;
          }
          this.childHeaderInput = response.data.responseData;
          this.kojoJotaiKbObj = {
            meishoCd: this.childHeaderInput.kojoJotaiKb,
          };
        })
        .catch((error: any) => {
          console.log('error', error);
        });
    },
    // PDF出力
    handlePdfOut() {
      const linkSource = this.childHeaderInput.tempShiryo;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = this.childHeaderInput.tempFileName;
      downloadLink.click();
    },
    handleRenraku() {
      let renrakuItem = {
        hatchuJigyoshoCd: this.childHeaderInput.hatchuJigyoshoCd,
        hatchuEntryYmd: this.childHeaderInput.hatchuEntryYmd,
        hatchuNo: this.childHeaderInput.hatchuNo,
        hatchuShuseiCount: this.childHeaderInput.hatchuShuseiCount,
        hatchuRenrakuJiko: this.childHeaderInput.hatchuRenrakuJiko,
      };
      this.shoriKb;
      this.childShowRenrakuEntry = true;
      this.childRenrakuItem = renrakuItem;
    },
    // 発注連絡事項を起動
    async handleRenrakuEntry() {
      this.showRenrakuEntry = true;
    },
    // 発注連絡事項を閉じる
    handleCloseRenrakuEntry() {
      this.showRenrakuEntry = false;
    },
    //別紙添付データ取得
    getAttachedData() {
      this.$store.dispatch('common/setIsLoading', true);
      if (this.childHeaderInput.tempShiryo) {
        this.showPreviewPDF = true;
        this.$store.dispatch('common/setIsLoading', false);
      } else {
        const params = {
          tempEntryYmd: this.childHeaderInput.tempEntryYmd,
          tempSeq: this.childHeaderInput.tempSeq,
          tempMukoFlg: this.childHeaderInput.tempMukoFlg,
        };

        this.$store
          .dispatch('common/getBesshiTemp', params)
          .then((res: any) => {
            if (
              res &&
              res.status == 200 &&
              res.data &&
              res.data.error &&
              res.data.error.outStatus &&
              res.data.error.outStatus != OutStatus.NORMAL
            ) {
              const { error } = res.data;
              this.showMessageDialog = true;
              this.messageID = error.messageID;
              this.messageTextParam = error.messageArgs;
              this.$store.dispatch('common/setIsLoading', false);
              return;
            }
            if (!res.data.responseData) {
              this.showMessageDialog = true;
              this.messageID = 'KI_W124';
              this.messageTextParam = [];
              this.$store.dispatch('common/setIsLoading', false);
              return;
            }
            this.childHeaderInput.tempShiryo = res.data.responseData.tempShiryo;
            this.showPreviewPDF = true;
            this.$store.dispatch('common/setIsLoading', false);
          });
      }
    },
  },
  watch: {
    kojoJotaiKbObj: {
      handler(value: any) {
        if (value && value.meishoCd) {
          this.childHeaderInput.kojoJotaiKb = value.meishoCd;
        } else {
          this.childHeaderInput.kojoJotaiKb = 0;
        }
      },
      immediate: true,
    },
  },

  created() {
    if (this.$attrs.childHeaderInput) {
      // ローディング・スタート
      this.$store.dispatch('common/setIsLoading', true);
      this.childHeaderInput = this.$attrs.childHeaderInput;
      this.childHeaderInput.juchuYmd = dateNumToStr(
        this.$attrs.childHeaderInput.juchuYmd
      );
      this.getData();
    }
    this.getKojoJotaiKbSelectedItems();
  },
  mounted() {
    setTimeout(() => {
      // ローディング・ストップ
      this.$store.dispatch('common/setIsLoading', false);
    }, 2000);
  },
});
